/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Application } from '../model/application';
import { RecentUserAccessLogRequest } from '../model/recentUserAccessLogRequest';
import { SwitchApplication } from '../model/switchApplication';
import { UserApplicationsRequest } from '../model/userApplicationsRequest';
import { ValidationResult } from '../model/validationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserApplicationsService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Applications - Users
     * This is for getting all the User by ApplicationId                Sample request:                POST /userapplications/list                {                    \&quot;Username\&quot;:\&quot;first.last@email.com\&quot;                }
     * @param userApplicationsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userApplicationsListPost(userApplicationsRequest?: UserApplicationsRequest, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public userApplicationsListPost(userApplicationsRequest?: UserApplicationsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public userApplicationsListPost(userApplicationsRequest?: UserApplicationsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public userApplicationsListPost(userApplicationsRequest?: UserApplicationsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Application>(`${this.configuration.basePath}/UserApplications/list`,
            userApplicationsRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Recent
     * This is for getting all SwitchApplications by Username between dates                Sample request:                POST /userapplications/recent/list                {                    \&quot;Username\&quot;:\&quot;first.last@email.com\&quot;,                    \&quot;StartDate\&quot;: \&quot;\&quot;,                    \&quot;EndDate\&quot;: \&quot;\&quot;                }
     * @param recentUserAccessLogRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userApplicationsRecentListPost(recentUserAccessLogRequest?: RecentUserAccessLogRequest, observe?: 'body', reportProgress?: boolean): Observable<Array<SwitchApplication>>;
    public userApplicationsRecentListPost(recentUserAccessLogRequest?: RecentUserAccessLogRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SwitchApplication>>>;
    public userApplicationsRecentListPost(recentUserAccessLogRequest?: RecentUserAccessLogRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SwitchApplication>>>;
    public userApplicationsRecentListPost(recentUserAccessLogRequest?: RecentUserAccessLogRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<SwitchApplication>>(`${this.configuration.basePath}/UserApplications/recent/list`,
            recentUserAccessLogRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// /ng-app/src/apiModule/api/userApplications.service.ts